import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { agregarCereal, obtenerCerealesTodos } from '../../../Cereal/actions'
import NuevoCereal from '../../components/cereales/NuevoCereal'
import { toast, ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import CerealesView from '../../components/cereales/CerealesView'
import { FORM_CEREALES } from '../../../../config/forms'
import { reduxForm, formValueSelector } from 'redux-form'

function ConfiguracionCereales (props) {
  const { obtenerCerealesTodos, agregarCereal } = props

  useEffect(() => {
    obtenerCerealesTodos()
  }, [obtenerCerealesTodos])

  const handleNuevoCereal = () => {
    const { nombreCorto, nombreCereal, humedad } = props
    if (nombreCorto && nombreCereal && humedad) {
      agregarCereal()
    } else {
      toast.error('Debe ingresar todos los campos requeridos (*)')
    }
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <NuevoCereal handleAdd={handleNuevoCereal} />
      <CerealesView />
    </>
  )
}

const selector = formValueSelector(FORM_CEREALES)

const mapActionsToProps = {
  obtenerCerealesTodos,
  agregarCereal
}

const mapStateToProps = (state) => ({
  nombreCorto: selector(state, 'nombreCorto'),
  nombreCereal: selector(state, 'nombreCereal'),
  humedad: selector(state, 'humedad')
})

const withReduxForm = reduxForm({
  form: FORM_CEREALES
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(ConfiguracionCereales))
